export default __webpack_public_path__ + "static/media/BackgroundImage.770b3e4a.png";